import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { debounce } from "underscore";


export class NavigationPane {
    ESC_keyCode = 27;

    events = {
        open: 'open-navigation',
        close: 'close-navigation'
    };

    overlayTPL = '<div class="navigation__overlay" />';

    // staff
    window = $(window);
    body;
    header;
    pane;
    button;
    buttonSearch;

    constructor() {
        this.onInit();
    };

    onInit() {
        this.header = $('#header');
        this.pane = $('.navigation-pane');
        this.button = $('.navigation-button');
        this.buttonSearch = $('.search-button');
        this.body = $('body');
        this.overlay = $(this.overlayTPL).appendTo(this.body);

        if (!this.pane.length || !this.button.length || !this.buttonSearch) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.window
            .on(this.events.close, (e) => this.onClose(e))
            .on(this.events.open, (e) => this.onOpen(e))
            .resize(debounce(() => {
                this.updateTop();
            }, 16))
            .keyup((e) => this.onKeyup(e));

        this.button.click((e) => this.onClick(e));
        this.buttonSearch.click((e) => this.onClick(e));
        this.pane.on('click', '.dropdown-lnk', (e) => this.onDropdown(e));
        this.pane.on('click', '.subdropdown-lnk', (e) => this.onDropdown(e));
        this.overlay.click((e) => this.onClick(e));
    };

    // Events
    onClick(e) {
        e.preventDefault();

        if (this.isActive()) {
            this.window.trigger(this.events.close);
        } else {
            this.window.trigger(this.events.open);
        }
    }

    onClose(e) {
        e.preventDefault();

        this.button.removeClass('navigation-button--active');
        this.pane.removeClass('navigation-pane--active');
        this.body.removeClass('navigation--active');
        this.overlay.removeClass('navigation__overlay--active');
    };

    onOpen(e) {
        e.preventDefault();

        this.updateTop();
        this.button.addClass('navigation-button--active');
        this.pane.addClass('navigation-pane--active');
        this.body.addClass('navigation--active');
        this.overlay.addClass('navigation__overlay--active');
    };

    onDropdown(e) {
        e.preventDefault();
        $(e.target).toggleClass('dropdown-lnk--active');
        $(e.target).parent().toggleClass('navigation-pane__subdropdown--active');
    }

    onKeyup(e) {
        e.preventDefault();

        if (e.keyCode !== this.ESC_keyCode) {
            return;
        }

        this.window.trigger(this.events.close);
    }

    // Functions
    updateTop() {
        const offsetTop = this.header.find('.masthead').outerHeight();
        let scrollTop = $(window).scrollTop();
        let elementOffset = this.header.find('.masthead').offset().top;
        let distance = (offsetTop + elementOffset) - scrollTop;

        this.pane.css('top', distance);
    }

    isActive() {
        return this.pane.is('.navigation-pane--active');
    }

    // auxiliary
    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }
}
